import { isAtLeast, isAtMost, isAbove, isBelow } from "./comparisons";

// TV Williams Fractals: up to this many bars right before the centre may equal it
const MAX_EQUAL_BARS = 4;

// `beats(centre, other)`: the centre is strictly beyond the other value;
// `ties(other, centre)`: the other value does not go beyond the centre
const isFractal = (values, centre, period, beats, ties) => {
  const centreValue = values(centre);

  for (let distance = 1; distance <= period; distance += 1) {
    if (!beats(centreValue, values(centre + distance))) return false;
  }

  for (let equalCount = 0; equalCount <= MAX_EQUAL_BARS; equalCount += 1) {
    let isLeftSideOk = true;

    for (let distance = 1; distance <= equalCount && isLeftSideOk; distance += 1) {
      isLeftSideOk = ties(values(centre - distance), centreValue);
    }

    for (let distance = 1; distance <= period && isLeftSideOk; distance += 1) {
      isLeftSideOk = beats(centreValue, values(centre - equalCount - distance));
    }

    if (isLeftSideOk) return true;
  }

  return false;
};

const priceOf = (bars, key) => (index) => (index >= 0 && index < bars.length ? bars[index][key] : NaN);

/**
 * Up fractal as in TV Williams Fractals: the high of `centre` is above the
 * highs of `period` bars on the right and on the left (up to 4 bars right
 * before it may equal it, then `period` lower ones).
 *
 * @param {object[]} bars
 * @param {number} centre
 * @param {number} period
 * @returns {boolean}
 */
export const isUpFractal = (bars, centre, period) =>
  isFractal(priceOf(bars, "high"), centre, period, isAbove, isAtMost);

/** Down fractal: the same with the lows, the centre below its neighbours. */
export const isDownFractal = (bars, centre, period) =>
  isFractal(priceOf(bars, "low"), centre, period, isBelow, isAtLeast);
